export default "__VITE_ASSET__262b8de3__"